import { useEffect, useState } from 'react';

import { ButtonSpinnerDarkIcon } from '@svgs';

export const DisassociateLocation = ({
  locationData,
  updateSite,
  siteData,
}) => {
  // disassociate confirmation
  const [showConfirmation, setShowConfirmation] = useState(false);

  // shared isPending
  const isPending = updateSite.isPending;

  useEffect(() => {
    // reset the confirmation state when the location changes
    setShowConfirmation(false);
  }, [locationData]);

  const onDisassociateLocation = async () => {
    // updated list of locations excluding the current location
    const siteLocationIds = siteData.location_ids.filter(
      (id) => id !== locationData.id,
    );
    updateSite.mutate({
      locations: siteLocationIds,
    });
  };

  return (
    <div className="sb-message sb-flex sb-message-delete">
      <div className="sb-flex sb-message-delete-inner">
        <span className="sb-message-icon"></span>
        <div className="sb-message-content">
          <p className="sb-message-title">
            Disassociate this location from the website
          </p>
          <p className="sb-message-msg">
            This location will be removed from the website's list of locations,
            but not deleted
          </p>
        </div>
      </div>
      {(!showConfirmation || isPending) && (
        <button
          type="button"
          className="sb-btn sb-btn-delete"
          onClick={() => setShowConfirmation(true)}
        >
          {isPending ? `Disassociating...` : 'Disassociate'}
          {isPending && <ButtonSpinnerDarkIcon />}
        </button>
      )}
      {showConfirmation && !isPending && (
        <div>
          <button
            type="button"
            className="sb-btn sb-btn-delete-confirm"
            onClick={onDisassociateLocation}
          >
            Confirm disassociation
          </button>
          <button
            type="button"
            className="sb-btn sb-btn-delete"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};
